import BitcoinFOMODApp from "./components/BitcoinFOMODApp";
import CountdownPage from "./components/CountDownPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TermsOfUse from "./components/TermConditions/TermsOfUse";
import PrivacyPolicy from "./components/TermConditions/PrivacyPolicy";
import Disclaimers from "./components/TermConditions/Disclaimers";

import LaunchCountdown from "./components/LaunchCountDown";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BitcoinFOMODApp />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/disclaimers" element={<Disclaimers />} />
      </Routes>
    </Router>
    // <div className="App">
    // <BitcoinFOMODApp />
    // <CountdownPage />
    // <LaunchCountdown />
    // </div>
  );
}

export default App;
